import React, { Component } from 'react';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from 'react-accessible-accordion';
import toggleColorPicker from '../../Functions/toggleColorPicker';
import Container from './monthlypayment/containerStyling';
import Header from './monthlypayment/header';
import Result from './monthlypayment/result';
import Layout from './monthlypayment/layout';
import FieldStyles from './monthlypayment/fieldStyles';
import Colors from './monthlypayment/colors';
import ToggleSwitch from '../fields/ToggleSwitch';

class MonthlyPayment extends Component {
    constructor(props) {
        super(props);
        const { widget } = this.props;
        const { htmlData } = widget;
        this.state = {
            widget: {
                htmlData: {
                    monthlypayment: {
                        container: {
                            bgColor: htmlData?.monthlypayment?.container?.bgColor || '#ffffff',
                            padding: htmlData?.monthlypayment?.container?.padding || '20px',
                            borderColor: htmlData?.monthlypayment?.container?.borderColor || '#dee2e6',
                            borderRadius: htmlData?.monthlypayment?.container?.borderRadius || '8px',
                            shadow: htmlData?.monthlypayment?.container?.shadow || '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        header: {
                            title: htmlData?.monthlypayment?.header?.title || 'Mortgage Calculator',
                            fontFamily: htmlData?.monthlypayment?.header?.fontFamily || 'Helvetica Neue, sans-serif',
                            fontSize: htmlData?.monthlypayment?.header?.fontSize || '32px',
                            fontWeight: htmlData?.monthlypayment?.header?.fontWeight || 'bold',
                            textAlign: htmlData?.monthlypayment?.header?.textAlign || 'center',
                            textColor: htmlData?.monthlypayment?.header?.textColor || '#333333',
                        },
                        result: {
                            textColor: htmlData?.monthlypayment?.result?.textColor || '#333333',
                            fontFamily: htmlData?.monthlypayment?.result?.fontFamily || 'Helvetica Neue, sans-serif',
                            fontSize: htmlData?.monthlypayment?.result?.fontSize || '22px',
                            fontWeight: htmlData?.monthlypayment?.result?.fontWeight || 'bold',
                            textAlign: htmlData?.monthlypayment?.result?.textAlign || 'left',
                        },
                        fields: {
                            fontSize: htmlData?.monthlypayment?.fields?.fontSize || '16px', // Renamed
                            fontWeight: htmlData?.monthlypayment?.fields?.fontWeight || 'normal', // Renamed
                            fontFamily: htmlData?.monthlypayment?.fields?.fontFamily || 'Helvetica Neue, sans-serif', // Renamed
                            textColor: htmlData?.monthlypayment?.fields?.textColor || '#333333', // Renamed
                            homePriceDefaultValue: htmlData?.monthlypayment?.fields?.homePriceDefaultValue || 1550000,
                            homePriceShowSlider: htmlData?.monthlypayment?.fields?.homePriceShowSlider !== undefined ? htmlData?.monthlypayment?.fields?.homePriceShowSlider : true,
                            homePriceSliderMin: htmlData?.monthlypayment?.fields?.homePriceSliderMin || 1240000,
                            homePriceSliderMax: htmlData?.monthlypayment?.fields?.homePriceSliderMax || 1860000,
                            
                            defaultDownPaymentPercent: htmlData?.monthlypayment?.fields?.defaultDownPaymentPercent || 20,
                            downPaymentShowSlider: htmlData?.monthlypayment?.fields?.downPaymentShowSlider !== undefined ? htmlData?.monthlypayment?.fields?.downPaymentShowSlider : true,
                            
                            interestRateDefaultValue: htmlData?.monthlypayment?.fields?.interestRateDefaultValue || 6,
                            
                            propertyTaxAnnualRate: htmlData?.monthlypayment?.fields?.propertyTaxAnnualRate || 1.25,
                            
                            homeInsuranceDefaultValue: htmlData?.monthlypayment?.fields?.homeInsuranceDefaultValue || 388,
                            
                            hoaFeesDefaultValue: htmlData?.monthlypayment?.fields?.hoaFeesDefaultValue || 0,
                            
                            mortgageInsuranceThreshold: htmlData?.monthlypayment?.fields?.mortgageInsuranceThreshold || 20,
                            mortgageInsuranceShowThresholdNote: htmlData?.monthlypayment?.fields?.mortgageInsuranceShowThresholdNote !== undefined ? htmlData?.monthlypayment?.fields?.mortgageInsuranceShowThresholdNote : true,
                        },
                        layout: {
                            template: htmlData?.monthlypayment?.layout?.template || 'two-column',
                            fieldOrder: {
                                leftOrder: htmlData?.monthlypayment?.layout?.fieldOrder?.leftOrder || [
                                    'Principal & Interest',
                                    'homePrice',
                                    'downPayment',
                                    'loanType',
                                    'interestRate'
                                ],
                                rightOrder: htmlData?.monthlypayment?.layout?.fieldOrder?.rightOrder || [
                                    'propertyTax',
                                    'homeInsurance',
                                    'hoaFees',
                                    'mortgageInsurance'
                                ]
                            }
                        },
                        colors: {
                            principalDot: htmlData?.monthlypayment?.colors?.principalDot || '#4299e1',
                            taxDot: htmlData?.monthlypayment?.colors?.taxDot || '#f6ad55',
                            insuranceDot: htmlData?.monthlypayment?.colors?.insuranceDot || '#68d391',
                            hoaDot: htmlData?.monthlypayment?.colors?.hoaDot || '#9f7aea',
                            mortgageDot: htmlData?.monthlypayment?.colors?.mortgageDot || '#fc8181',
                        },
                    }
                },
                widgetType: widget.widgetType.id,
                widgetTypeName: widget.widgetType.name,
                widgetTypeScripts: widget.widgetType.scripts,
                title: widget.title ? widget.title : '',
                expires: widget.expires ? widget.expires : '',
                firstLoad: true
            }
        };
    }

    handleInputChange = (e) => {
        const { type, name, value, checked } = e.target;
        const inputValue = type === 'checkbox' ? checked : value;

        if (name === 'title') {
            const updatedWidget = {
                ...this.state.widget,
                title: inputValue,
                firstLoad: false
            };
            
            this.setState({ widget: updatedWidget });
            this.props.updateWrapperWidget(updatedWidget);
            return;
        }

        // Special handling for layout template
        if (name === 'layout-template') {
            const updatedWidget = {
                ...this.state.widget,
                firstLoad: false,
                htmlData: {
                    ...this.state.widget.htmlData,
                    monthlypayment: {
                        ...this.state.widget.htmlData.monthlypayment,
                        layout: {
                            ...this.state.widget.htmlData.monthlypayment.layout,
                            template: inputValue
                        }
                    }
                }
            };

            this.setState({ widget: updatedWidget });
            this.props.previewWidget(updatedWidget);
            return;
        }

    // Handle home price show/hide toggle separately
        if (name === 'fields-homePriceShowSlider') {
            const updatedWidget = { ...this.state.widget };
            updatedWidget.htmlData.monthlypayment.fields.homePriceShowSlider = checked;
            updatedWidget.firstLoad = false;

            this.setState({ widget: updatedWidget }, () => {
                this.props.previewWidget(updatedWidget);
                // Force UI refresh
                setTimeout(() => {
                    if (window.processMonthlyPaymentWidget) {
                        window.processMonthlyPaymentWidget();
                    }
                }, 50);
            });
        return;
        }

        // Handle home price numerical fields (min/max/default)
        if (['fields-homePriceSliderMin', 'fields-homePriceSliderMax', 'fields-homePriceDefaultValue'].includes(name)) {
            const { homePriceDefaultValue, homePriceSliderMin, homePriceSliderMax } = this.state.widget.htmlData.monthlypayment.fields;
            let newValue = parseInt(inputValue) || 0;
            
            // Cap all values at 999,999,999
            if (newValue > 999999999) {
                newValue = 999999999;
            }
        
            let newMin = homePriceSliderMin;
            let newMax = homePriceSliderMax;
            let newDefault = homePriceDefaultValue;
        
            // Update the appropriate value based on which field changed
            if (name === 'fields-homePriceSliderMin') {
            newMin = Math.max(1, newValue);
                if (newMin > newMax) {
                    newMax = newMin;
                }
            } else if (name === 'fields-homePriceSliderMax') {
                newMax = Math.max(1, newValue);
                if (newMax < newDefault) {
                    newDefault = newMax;
                }
                if (newMax < newMin) {
                    newMin = Math.max(1, newMax - 1);
                }
            } else if (name === 'fields-homePriceDefaultValue') {
                newDefault = Math.max(1, newValue);
                if (newDefault > newMax) {
                    newMax = newDefault;
                }
                if (newDefault < newMin) {
                    newMin = Math.max(1, newDefault - 1);
                }
            }
        
            // Update the state with corrected values
            const updatedWidget = { ...this.state.widget };
            updatedWidget.htmlData.monthlypayment.fields.homePriceSliderMin = newMin;
            updatedWidget.htmlData.monthlypayment.fields.homePriceSliderMax = newMax;
            updatedWidget.htmlData.monthlypayment.fields.homePriceDefaultValue = newDefault;
            updatedWidget.firstLoad = false;
        
            this.setState({ widget: updatedWidget }, () => {
                this.props.previewWidget(updatedWidget);
                this.triggerCalculationUpdate();
            });
            return;
        }

        // Handle down payment toggle separately
        if (name === 'fields-downPaymentShowSlider') {
            const updatedWidget = { ...this.state.widget };
            updatedWidget.htmlData.monthlypayment.fields.downPaymentShowSlider = checked;
            updatedWidget.firstLoad = false;

            this.setState({ widget: updatedWidget }, () => {
                this.props.previewWidget(updatedWidget);
                setTimeout(() => {
                    if (window.processMonthlyPaymentWidget) {
                        window.processMonthlyPaymentWidget();
                    }
                }, 50);
            });
            return;
        }

    // Handle all other nested fields
        const path = name.split('-');
        let updatedWidget = { ...this.state.widget };
        let currentLevel = updatedWidget.htmlData.monthlypayment;

        for (let i = 0; i < path.length - 1; i++) {
            const key = path[i];
            currentLevel[key] = { ...currentLevel[key] };
            currentLevel = currentLevel[key];
        }

        const lastKey = path[path.length - 1];
        currentLevel[lastKey] = inputValue;

        updatedWidget.firstLoad = false;
        this.setState({ widget: updatedWidget }, () => {
            this.props.previewWidget(updatedWidget);
            this.triggerCalculationUpdate();
        });
    };

// Add this new method
    triggerCalculationUpdate = () => {
        setTimeout(() => {
            if (window.triggerFieldUpdates) {
                window.triggerFieldUpdates();
            } else if (window.calculateAndUpdate) {
                window.calculateAndUpdate();
            }
        }, 100);
    };

    setColorsAndPreview = (section, stateItem, value) => {
    const updatedWidget = {
        ...this.state.widget,
        firstLoad: false,
        htmlData: {
            ...this.state.widget.htmlData,
            monthlypayment: {
                ...this.state.widget.htmlData.monthlypayment,
                [section]: {
                    ...this.state.widget.htmlData.monthlypayment[section],
                    [stateItem]: value,
                },
            },
        },
    };

    this.setState({ widget: updatedWidget });
    this.props.previewWidget(updatedWidget);
};

    async componentDidMount() {
        const { previewWidget } = this.props;
        await previewWidget(this.state.widget);
    }

    render() {
        const { widget } = this.state;
        const { selectedEditor } = this.props;
        const { title, htmlData } = widget;
        const { monthlypayment } = htmlData;

        return (
            <div className="mjwi-editor-main-inner">
                {selectedEditor === 'Builder' && (
                    <div className="mjwi-editor-builder">
                        <label htmlFor="title">Widget Name</label>
                        <input
                            type="text"
                            name="title"
                            value={title}
                            placeholder="Title"
                            onChange={this.handleInputChange}
                        />

                        <Accordion allowZeroExpanded>
                            <AccordionItem>
                                <AccordionItemHeading>
                                    <AccordionItemButton>Default Values</AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    <div className="mjwi-acc-panel-wrapper">
                                        <div className="mjwi-row">
                                            <div className="mjwi-col50">
                                                <label>Home Price</label>
                                            </div>
                                            <div className="mjwi-col50">
                                                <input
                                                    type="number"
                                                    name="fields-homePriceDefaultValue"
                                                    value={monthlypayment.fields.homePriceDefaultValue || ''}
                                                    onChange={this.handleInputChange}
                                                    className="mjwi-input"
                                                />
                                            </div>
                                        </div>
                                        <div className="mjwi-row">
                                            <div className="mjwi-col50">
                                                <label>Down Payment Percent</label>
                                            </div>
                                            <div className="mjwi-col50">
                                                <input
                                                    type="number"
                                                    name="fields-defaultDownPaymentPercent"
                                                    value={monthlypayment.fields.defaultDownPaymentPercent || ''}
                                                    onChange={(e) => {
                                                        let value = parseInt(e.target.value) || 0;
                                                        value = Math.min(value, 100); // Cap at 100
                                                        this.handleInputChange({ target: { name: e.target.name, value } });
                                                    }}
                                                    className="mjwi-input"
                                                    min="0" max="100"
                                                />
                                            </div>
                                        </div>
                                        <div className="mjwi-row">
                                            <div className="mjwi-col50">
                                                <label>Interest Rate</label>
                                            </div>
                                            <div className="mjwi-col50">
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    name="fields-interestRateDefaultValue"
                                                    value={monthlypayment.fields.interestRateDefaultValue || ''}
                                                    onChange={this.handleInputChange}
                                                    className="mjwi-input"
                                                />
                                            </div>
                                        </div>
                                        <div className="mjwi-row">
                                            <div className="mjwi-col50">
                                                <label>Property Tax Annual Rate</label>
                                            </div>
                                            <div className="mjwi-col50">
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    name="fields-propertyTaxAnnualRate"
                                                    value={monthlypayment.fields.propertyTaxAnnualRate || ''}
                                                    onChange={this.handleInputChange}
                                                    className="mjwi-input"
                                                />
                                            </div>
                                        </div>
                                        <div className="mjwi-row">
                                            <div className="mjwi-col50">
                                                <label>Home Insurance</label>
                                            </div>
                                            <div className="mjwi-col50">
                                                <input
                                                    type="number"
                                                    name="fields-homeInsuranceDefaultValue"
                                                    value={monthlypayment.fields.homeInsuranceDefaultValue || ''}
                                                    onChange={this.handleInputChange}
                                                    className="mjwi-input"
                                                />
                                            </div>
                                        </div>
                                        <div className="mjwi-row">
                                            <div className="mjwi-col50">
                                                <label>HOA Fees</label>
                                            </div>
                                            <div className="mjwi-col50">
                                                <input
                                                    type="number"
                                                    name="fields-hoaFeesDefaultValue"
                                                    value={monthlypayment.fields.hoaFeesDefaultValue || '0'}
                                                    onChange={this.handleInputChange}
                                                    className="mjwi-input"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </AccordionItemPanel>
                            </AccordionItem>

                            <AccordionItem>
                                <AccordionItemHeading>
                                    <AccordionItemButton>Sliders</AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    <div className="mjwi-acc-panel-wrapper">
                                        {/* Home Price Slider Settings */}
                                        <div className="mjwi-row">
                                            <div className="mjwi-col50">
                                                <label>Show Home Price Slider</label>
                                            </div>
                                            <div className="mjwi-col50">
                                                <ToggleSwitch
                                                    name="fields-homePriceShowSlider"
                                                    checked={monthlypayment.fields.homePriceShowSlider}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>

                                        {monthlypayment.fields.homePriceShowSlider && (
                                            <>
                                                <div className="mjwi-row">
                                                    <div className="mjwi-col50">
                                                        <label>Home Price Min</label>
                                                    </div>
                                                    <div className="mjwi-col50">
                                                        <input
                                                            type="number"
                                                            name="fields-homePriceSliderMin"
                                                            value={monthlypayment.fields.homePriceSliderMin}
                                                            onChange={this.handleInputChange}
                                                            className="mjwi-input"
                                                            min="0"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mjwi-row">
                                                    <div className="mjwi-col50">
                                                        <label>Home Price Max</label>
                                                    </div>
                                                    <div className="mjwi-col50">
                                                        <input
                                                            type="number"
                                                            name="fields-homePriceSliderMax"
                                                            value={monthlypayment.fields.homePriceSliderMax}
                                                            onChange={this.handleInputChange}
                                                            className="mjwi-input"
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        {/* Down Payment Slider Settings */}
                                        <div className="mjwi-row">
                                            <div className="mjwi-col50">
                                                <label>Show Down Payment Slider</label>
                                            </div>
                                            <div className="mjwi-col50">
                                                <ToggleSwitch
                                                    name="fields-downPaymentShowSlider"
                                                    checked={monthlypayment.fields.downPaymentShowSlider}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </AccordionItemPanel>
                            </AccordionItem>
                        </Accordion>
                    </div>
                )}

                {selectedEditor === 'Layout' && (
                    <div className="mjwi-editor-layout">
                        <Accordion allowZeroExpanded>
                            <AccordionItem>
                                <AccordionItemHeading>
                                    <AccordionItemButton>Container</AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    <Container
                                        widget={widget}
                                        handleInputChange={this.handleInputChange}
                                        setColorsAndPreview={this.setColorsAndPreview}
                                    />
                                </AccordionItemPanel>
                            </AccordionItem>

                            <AccordionItem>
                                <AccordionItemHeading>
                                    <AccordionItemButton>Header</AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    <Header
                                        widget={widget}
                                        handleInputChange={this.handleInputChange}
                                        setColorsAndPreview={this.setColorsAndPreview}
                                    />
                                </AccordionItemPanel>
                            </AccordionItem>

                            <AccordionItem>
                                <AccordionItemHeading>
                                    <AccordionItemButton>Result</AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    <Result
                                        widget={widget}
                                        handleInputChange={this.handleInputChange}
                                        setColorsAndPreview={this.setColorsAndPreview}
                                    />
                                </AccordionItemPanel>
                            </AccordionItem>

                            <AccordionItem>
                                <AccordionItemHeading>
                                    <AccordionItemButton>Layout</AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    <Layout
                                        widget={widget}
                                        handleInputChange={this.handleInputChange}
                                    />
                                </AccordionItemPanel>
                            </AccordionItem>

                            <AccordionItem>
                                <AccordionItemHeading>
                                    <AccordionItemButton>Fields</AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    <FieldStyles
                                        widget={widget}
                                        handleInputChange={this.handleInputChange}
                                        setColorsAndPreview={this.setColorsAndPreview}
                                    />
                                </AccordionItemPanel>
                            </AccordionItem>

                            <AccordionItem>
                                <AccordionItemHeading>
                                    <AccordionItemButton>Colors</AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    <Colors
                                        widget={widget}
                                        setColorsAndPreview={this.setColorsAndPreview}
                                    />
                                </AccordionItemPanel>
                            </AccordionItem>
                        </Accordion>
                    </div>
                )}
            </div>
        );
    }
}

export default MonthlyPayment;